import { css } from "@emotion/react";

export const parentNodeIconStyles = {
  listItemIcon: css({
    minWidth: "auto",
  }),
  animationContainer: ({ rotate }: { rotate: number }) =>
    css({
      transform: `rotate(${rotate}deg)`,
      transition: "transform 0.3s",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
    }),
  arrow: (color?: string) => (color ? css({ color }) : undefined),
};
